import Divider from "../components/divider.js";

import img1 from "../assets/img/_1058371.webp";
import img2 from "../assets/img/Seminarhaus_Hof.webp";
import img3 from "../assets/img/Tanzraum.webp";
import img4 from "../assets/img/Seminarhaus.webp";

function Gruppenangebote() {
  return <div className="main-wrapper">
    
    

    

    <h2>Gruppenangebote</h2>

    <p>
      2026/2027 biete ich wieder einen Jahreskurs „Kreativer Tanz & Heilsame Bewegung“ an, vier Wochenenden Lebendigkeit & Kreativität entdecken, sich wieder besser spüren, bei sich liebevoll ankommen. Freie Bewegung, ohne Vorkenntnisse, ohne vorgegebene Schritte, ohne Leistungsdruck, in einer kleinen Gruppe, in einem sicheren Raum. Erholung für die Sinne, Entspannung für das Nervensystem, Ressourcen erkennen und stärken, Resilienz aufbauen.
    </p>

    <div className="center">
      <img className="size50" src={img1}></img>
    </div>

    <h3 className="strong font-color">
      Zeit für mich – für innere Ruhe & Kraft
    </h3>

    <p className="strong font-color">
      Kreativer Tanz & Heilsame Bewegung Neue Termine 2026/2027
    </p>

    <p className="strong font-color">
      19.-21. Juni 2026 — Sommerwochenende<br/>
      2.-4. Oktober 2026 — Herbstwochenende<br/>
      15.-17. Januar 2027 — Winterwochenende
    </p>

    <p className="strong font-color">
      Eine bewusste Auszeit.<br/>
      Das Leben wieder spüren.<br/>
      In Verbindung sein. Mit mir, den Anderen, und der Natur.<br/>
      Lauschen auf das, was mein Körper mir sagt.<br/>
      Spüren, was mir genau jetzt guttut.
    </p>

    <Divider/>

    <p>
      Ein ganzes Wochenende freier, kreativer Tanz und nährende, heilsame Bewegung unterstützen dich und geben dir <strong className="strong font-color">Impulse für den Alltag</strong> mit Elementen aus der Holistischen Tanztherapie, Continuum und sensitivem Yoga. Es sind <strong className="strong font-color">keine Vorkenntnisse</strong> notwendig. Du bist willkommen, so wie du bist. Es geht nicht darum, bestimmte Schrittfolgen oder eine Methode zu erlernen, sondern dem eigenen Bewegungsfluss zu folgen. Selbsterfahrung und <strong className="strong font-color">Stärkung der Intuition</strong> stehen im Mittelpunkt.
    </p>

    <p>
      Wir haben ein einfaches, ruhiges Seminarhaus auf dem Land ganz für uns, mit einem <strong className="strong font-color">wunderbaren hellen Tanzraum</strong>, schönem Holzboden und <strong className="strong font-color">Fußbodenheizung</strong>. Es befindet sich an einem kraftvollen Ort im Nördlinger Ries am Kraterrand, eine <strong className="strong font-color">einzigartige Landschaft</strong>. Es gibt leckeres vegetarisches Essen, frisch zubereitet, vorwiegend bio & regional.
    </p>

    <div className="center">
      <img className="size50" src={img2}></img>
    </div>
    
    <h3>
      Ablauf
    </h3>

    <p>
      Freitag: ab 15:30 Ankommen, Zimmer beziehen, Start 18 Uhr<br/>
      Samstag: 2 Kurseinheiten (davon 1 Einheit draußen, je nach Wetter)<br/>
      Sonntag: 1 Kurseinheit, Mittagessen, Abschlusskreis (Ende ca. 15:30)
    </p>

    <h3>
      Kosten & Bedingungen
    </h3>

    <p>
      <div className="bulletpoint"/>Wochenende inkl. Übernachtung & Verpflegung: 395 Euro<br/>
      <div className="bulletpoint"/>Jahreskurs: 4 aufeinanderfolgende Wochenenden: insg. 1400 Euro (Verrechnung beim 4. Wochenende; weitere Termine: Herbstwochenende: 2.-4. Oktober 2026, Winterwochenende: 15.-17. Januar 2027, Frühlingswochenende geplant für April 2027)<br/>
      <div className="bulletpoint"/>Anzahlung bei Anmeldung: 150 Euro (entspricht den Stornogebühren)<br/>
      <div className="bulletpoint"/>Einzelzimmerzuschlag: 60 Euro je Wochenende
    </p>

    <h3>
      Info & Anmeldung
    </h3>

    <p>
      Telefon: <a href="tel:+49 89 43630078">+49 89 43630078</a><br/>
      E-Mail: <a href="mailto:info@solveig-bissinger.de">info@solveig-bissinger.de</a>
    </p>

    <a href="../files/2026_SommerTanzWochenende.pdf" target="_blank" rel="noopener noreferrer">
      Flyer ansehen
    </a>

    <img className="size53 left" src={img3}></img>
    <img className="size53 right" src={img4}></img>


  </div>;
}
export default Gruppenangebote;